import { render } from "./NavBarButton.vue?vue&type=template&id=4c4e64ff"
import script from "./NavBarButton.vue?vue&type=script&lang=js"
export * from "./NavBarButton.vue?vue&type=script&lang=js"

import "./NavBarButton.vue?vue&type=style&index=0&id=4c4e64ff&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__